import { ovalModeActive } from '@classes/app_url_params'
import { AppConfig, getConfigArray, getConfigBoolean } from '@config'
import { set } from 'lodash'
import { useEffect, useState } from 'react'

import type { Gauge, GaugesVisibility, Grid, OvalSide } from './types'
import { IndexJsonKeyPaths } from './types'

const initialOptions: GaugesVisibility = {
  wind: {
    order: 0,
    active: false
  },
  heading: {
    order: 0,
    active: false
  },
  speed: {
    order: 0,
    active: false
  },
  temperature: {
    order: 0,
    active: false
  },
  depth: {
    order: 0,
    active: false
  },
  pressure: {
    order: 0,
    active: false
  },
  time: {
    order: 0,
    active: false
  },
  mekkah: {
    order: 0,
    active: false
  },
  location: {
    order: 0,
    active: false
  },
  eco_score: {
    order: 0,
    active: false
  }
}

const useGauge = (ovalSide?: OvalSide): [Gauge[] | null, GaugesVisibility, boolean] => {
  const [gauges, setGauges] = useState<Gauge[] | null>([])
  const [options, setOptions] = useState<GaugesVisibility>(initialOptions)
  const [showMekka, setShowMekka] = useState(true)

  useEffect(() => {
    const gauges: Gauge[] | null = getConfigArray<Gauge>(IndexJsonKeyPaths.LAYOUT)
    const mode: Grid | string = AppConfig.getGaugeGridLayout()
    const showMekkah: boolean = getConfigBoolean(IndexJsonKeyPaths.MEKKA)

    const leftSideIndexes = [0, 2, 5]
    const rightSideIndexes = [1, 3, 6]

    const newOptions = { ...options }

    if (gauges && gauges.length && mode) {
      gauges.forEach((item, index) => {
        const type = mode.split('x')

        // counting how many items should be in layout
        const sum = ovalModeActive() ? 7 : type.reduce((prev, curr) => Number(prev) + Number(curr), 0)

        // setting order and decide if gauge should display
        if (item.name) {
          let active = sum >= index + 1

          if (ovalSide === 'left' && leftSideIndexes.indexOf(index) === -1) {
            active = false
          }

          if (ovalSide === 'right' && rightSideIndexes.indexOf(index) === -1) {
            active = false
          }

          set(newOptions, item.name.toLowerCase(), { order: index + 1, active })
        }
      })
    }

    setOptions(newOptions)

    setShowMekka(showMekkah && showMekkah)

    if (gauges && gauges.length) {
      setGauges(gauges)
    }
  }, [ovalSide])

  return [gauges, options, showMekka]
}

export default useGauge
